import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { METHODS, SERVICES } from '../../api/constants';
import { commonMoodlePayload } from '../../config';
import { makeRequest } from '../../api/api';
import { MOODLE_BACKEND_ROUTES } from '../../config/apiRoutes';
import { toast } from 'react-toastify';

export const markVideoCompleted = createAsyncThunk(
  'paidActivity/markVideoCompleted',
  async (param, thunkApi) => {
    try {
      await makeRequest(SERVICES.MOODLE_SERVICE, '', METHODS.GET, {
        ...param,
        ...commonMoodlePayload,
        wsfunction: MOODLE_BACKEND_ROUTES.SET_VIDEO_AS_WATCHED,
        wstoken: thunkApi.getState().auth.token
      });
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const fetchResumeTime = createAsyncThunk(
  'paidActivity/fetchResumeTime',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(SERVICES.MOODLE_SERVICE, '', METHODS.GET, {
        ...param,
        ...commonMoodlePayload,
        component: 'mod_videofile',
        method: 'mobile_video_view',
        wsfunction: MOODLE_BACKEND_ROUTES.GET_VIDEO_WATCHED_PROGRESS,
        wstoken: thunkApi.getState().auth.token
      });

      return response?.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

const paidActivitySlice = createSlice({
  name: 'paidActivity',
  initialState: {
    fetchResumeTime: {
      isLoading: false,
      videoStateData: {},
      error: ''
    }
  },
  reducers: {
    // setDownloadLinkDataEmpty: (state, action) => {
    //   state.getActivityDownloadLink = {
    //     ...state.getActivityDownloadLink,
    //     downloadLinkData: action?.payload
    //   };
    // }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchResumeTime.pending, (state) => {
      state.fetchResumeTime.isLoading = true;
    });
    builder.addCase(fetchResumeTime.fulfilled, (state, action) => {
      state.fetchResumeTime.isLoading = false;
      state.fetchResumeTime.videoStateData = action?.payload || {};
    });
    builder.addCase(fetchResumeTime.rejected, (state) => {
      state.fetchResumeTime.isLoading = false;
    });
  }
});

// export const { setDownloadLinkDataEmpty } = courseSlice.actions;

export default paidActivitySlice.reducer;
